import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
    import { useLoading } from 'vue3-loading-overlay';
    import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'commonLoader',
  setup(__props, { expose: __expose }) {
  __expose();

    const isLoading = ref(false);
    const fullPage = ref(true);
    const onCancel = () => {
        isLoading.value = false;
    }

const __returned__ = { isLoading, fullPage, onCancel }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})